import { ReactNode } from "react";
import SuppliedVector from "../../../assets/IntegrityIcons/SuppliedVector";
import EpcVector from "../../../assets/IntegrityIcons/EpcVector";
import ClonedVector from "../../../assets/IntegrityIcons/ClonedVector";
import ConfirmedVector from "../../../assets/IntegrityIcons/ConfirmedVector";
import AssumedVector from "../../../assets/IntegrityIcons/AssumedVector";

export function getIntegrityIcon(integrityValue: number | string): ReactNode {
	switch (Number(integrityValue)) {
		case 1:
			return <AssumedVector />;
		case 2:
			return <ConfirmedVector />;
		case 3:
			return <ClonedVector />;
		case 4:
			return <EpcVector />;
		case 5:
			return <SuppliedVector />;
		case 6:
			return <ConfirmedVector />;
		default:
			return null;
	}
}
